import { services } from "../../../../constants/services";
import { getByQuery } from "../../../../utils/api";
import { IParamsResources, ResponseQ } from "../../../../common/dtos/paginate.dto";

export const GetReservationsWithPaginationService = async(params: IParamsResources) => {
  const response = await getByQuery<ResponseQ<any>>(`${services.booking}/getBooking`, params);
  return response;
};

